export default "__VITE_ASSET__38CwIPPp__"